import { Box, Checkbox, Text } from "@prismicio/editor-ui"

import { useSelectionManager } from "../../../SelectionManager"
import { useMediaLibrary } from "../MediaLibraryContext"
import { AssetCount } from "./AssetCount"
import { AssetTypeFilter, TagsFilter, UploaderFilter } from "./filters"

export function Toolbar() {
  const { media, mediaTotal } = useMediaLibrary()
  const selectionManager = useSelectionManager()

  return (
    <Box alignItems="center" gap={16}>
      {selectionManager.isSelectAllEnabled && (
        <Checkbox
          onCheckedChange={selectionManager.toggleSelectAll}
          checked={selectionManager.selectedCount > 0}
          indeterminate={selectionManager.selectedCount !== mediaTotal}
          onClick={(event) => event.stopPropagation()}
          disabled={media.length === 0}
        />
      )}
      {media.length !== 0 && <AssetCount count={mediaTotal} />}
      <Box gap={8} alignItems="center">
        <Text>Filter:</Text>
        <AssetTypeFilter />
        <UploaderFilter />
        <TagsFilter />
      </Box>
    </Box>
  )
}
